export const PREDICTED_SCORE_KEYS = [
  'centering_score',
  'compass_score',
  'depth_score',
  'gain_score',
  'lift_score',
  'null_score',
  'peak_score',
  'swing_score',
  'vertical_score'
];

export const averageScoresForKeys = (point, scoreKeys = PREDICTED_SCORE_KEYS) => {
  let sum = 0;
  let count = 0;

  scoreKeys.forEach(key => {
    const value = point?.[key];

    if (value === null || value === undefined || Number.isNaN(Number(value))) {
      return;
    }

    sum += Number(value);
    count += 1;
  });

  return count > 0 ? sum / count : null;
};

export const calculatePredictedOverallScore = (point, config = {}) => {
  const {
    scoreKeys = PREDICTED_SCORE_KEYS,
    strategy
  } = config;

  if (typeof strategy === 'function') {
    return strategy({
      point,
      scoreKeys,
      averageScoresForKeys
    });
  }

  return averageScoresForKeys(point, scoreKeys);
};
